import React, { useEffect, useState } from "react";
import { fetchGroups } from "src/Services/Groups/GroupService";
import { useRecoilState } from "recoil";
import { loadingState } from "src/atom/LoadingState";
import { fetchCandidateListing } from "src/Services/Candidate/CandidateService";
import Select from "src/components/form/Select";
import Text from "src/components/form/Text";
import CandidateTable from "./CandidateTable";
import Pagination2 from "src/components/Paginator";

const CandidateListing = () => {
  const [formData, setFormData] = useState({
    id: "",
    startDate: "",
    endDate: "",
    group: "",
    verification_status: "",
    final_status: "",
    userId: "",
  });
  const [loader, enableLoader] = useRecoilState(loadingState);
  const [groups, setGroups] = useState([]);
  const [candidate, setCandidate] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 0,
    totalItems: 0,
    totalPages: 0,
    next: "",
    prev: "",
    size: 10,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((formData) => ({
      ...formData,
      [name]: value,
    }));
  };

  const fetchGroupsAPICall = async () => {
    enableLoader(true);
    var fetchGroupsMethod = async () => {
      var response = await fetchGroups();
      if (response.success) {
        var groups_dict = [];
        response.body.forEach((element) => {
          groups_dict.push({"id":element.id, "value":element.group_id})
        });
        setGroups(groups_dict);
        enableLoader(false);
      } else {
        enableLoader(false);
      }
    };
    fetchGroupsMethod();
  };

  const handleSearch = (formData, set_page) => {
    var current_page = pagination.currentPage;
    if (set_page) {
      current_page = 1;
    }
    const getSearch = async () => {
      const response = await fetchCandidateListing({
        page: current_page,
        page_size: pagination.size,
        group: formData.group,
        candidate__transaction_id: formData.userId?formData.userId:"",
        start_date: formData.startDate?formData.startDate:"",
        end_date: formData.endDate?formData.endDate:"",
        verification_status: formData.verification_status?formData.verification_status:"",
        final_status: formData.final_status?formData.final_status:"",
      });
      if (response.success) {
        setCandidate(response.body);
        setPagination((prevValue) => ({
          ...prevValue,
          currentPage: response.body.page,
          perPage: pagination.size,
          totalItems: response.body.count,
          totalPages: Math.ceil(response.body?.count / pagination.size),
        }));
        enableLoader(false);
        localStorage.setItem("filters", JSON.stringify({
          page: current_page,
          page_size: pagination.size,
          group: formData.group,
          candidate__transaction_id: formData.userId,
          start_date: formData.startDate,
          end_date: formData.endDate,
          verification_status: formData.verification_status,
          final_status: formData.final_status,
        }))
      } else {
        enableLoader(false);
      }
    };
    if (formData.group) {
      getSearch();
    }
  };

  const setPage = (event) => {
    setPagination((prevValue) => ({
      ...prevValue,
      currentPage: event,
    }));
  };

  useEffect(() => {
    handleSearch(formData, false);
  }, [pagination.currentPage, pagination.size]);

  const handleClearFilters = async (e) => {
    enableLoader(true);
    setFormData((prevFormData) => ({
      ...prevFormData,
      id: "",
      startDate: "",
      endDate: "",
      verification_status: "",
      final_status: "",
      userId: "",
    }));
    enableLoader(false);
    handleSearch(
      {
        group: formData.group,
        id: "",
        startDate: "",
        endDate: "",
        verification_status: "",
        final_status: "",
        userId: "",
      },
      true
    );
  };

  useEffect(() => {
    fetchGroupsAPICall();
    var filters = JSON.parse(localStorage.getItem("filters"))
    setFormData(filters)
    
    
    if (filters) {
      if(filters?.group) {
        console.log(111111, filters)
        handleSearch(filters, false)
      }
      setPagination((prevValue) => ({
        ...prevValue,
        currentPage: filters?.page,
        size: filters?.page_size,
      }));
    }
    
  }, []);

  const verification_status_mapping = [
    {id:"NS", value: "Not started"},
    {id:"IP", value: "In Progress"},
    {id:"R", value: "Reviewed"},
    {id:"CS", value: "Communication Sent"},
    {id:"VC", value: "Verification Completed"},
    {id:"ACR", value: "Awaiting Candidate Response"},
    {id:"RR", value: "Re-review"},
    {id:"RRP", value: "Re-review In Progress"},
    {id:"RRD", value: "Re-reviewed"},
  ]

  const final_status_mapping = [
    {id:"A", value: "Approved"},
    {id:"R", value: "Rejected"}
  ]

  return (
    <div className="card">
      <div
        className="card-header text-white"
        style={{ backgroundColor: "#3C4B64" }}
      >
        <div className="d-flex align-items-center justify-content-between">
          <span className="mr-auto">
            Candidates Documents Verification Status
          </span>
        </div>
      </div>
      <div className="card-body">
        <form>
          <div className="row">
            <div className="col-md-12 mb-2">
              <Select
                data={formData?.group}
                options_mapping={groups}
                name="group"
                label="Group"
                handleInputChange={handleInputChange}
                width={39.5}
              ></Select>
            </div>
            {formData?.group && (
              <>
                <div className="col-md-6 mb-2">
                  <Text
                    data={formData?.startDate}
                    name="startDate"
                    label="Review Start Date"
                    handleInputChange={handleInputChange}
                    width={80}
                    type="date"
                  ></Text>
                </div>
                <div className="col-md-6 mb-2">
                  <Text
                    data={formData?.endDate}
                    name="endDate"
                    label="Review End Date"
                    handleInputChange={handleInputChange}
                    width={80}
                    type="date"
                  ></Text>
                </div>
                <div className="col-md-6 mb-2">
                  <Text
                    data={formData?.userId}
                    name="userId"
                    label="User ID"
                    handleInputChange={handleInputChange}
                    width={80}
                    type="text"
                    placeholder="Enter user id"
                  ></Text>
                </div>
                <div className="col-md-6 mb-2">
                  <Select
                    data={formData?.verification_status}
                    options_mapping={verification_status_mapping}
                    name="verification_status"
                    label="Verification status"
                    handleInputChange={handleInputChange}
                    width={80}
                  ></Select>
                </div>
                <div className="col-md-6 mb-2">
                  <Select
                    data={formData?.final_status}
                    options_mapping={final_status_mapping}
                    name="final_status"
                    label="Final status"
                    handleInputChange={handleInputChange}
                    width={80}
                  ></Select>
                </div>
                <div className="mt-3">
                  <button
                    type="button"
                    className="btn btn-sm btn-info text-white me-2"
                    onClick={() => handleSearch(formData, true)}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-info text-white me-2"
                    onClick={(e) => handleClearFilters(e)}
                  >
                    Clear Filters
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-success text-white"
                  >
                    Send Feedback
                  </button>
                </div>
                {candidate.results?.length ? (
                  <>
                    <CandidateTable
                      finalData={candidate}
                      groupId={formData.group}
                    />
                    <div className="row">
                      <div className="col-12 d-flex justify-content-center">
                        <Pagination2
                          pagination={pagination}
                          range={3}
                          setPage={setPage}
                          setPagination={setPagination}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="mt-3 ms-3">No data found</div>
                )}
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default CandidateListing;
